import Popover from "../popover/popover";
import Image from "next/image";
import { useRef } from "react";
import useOnClickOutside from "helpers/hooks/useOnClickOutside";
import { ConditionName, IConfirmationModalProps } from "interfaces";
import { conditions, isTouchScreen } from "helpers";
import IMAGES from "../../../../../images/importImages";

const ConfirmationModal = ({ modalType, onClose, cancelButtonText, submitButtonText, onSubmit, text, status, children }: IConfirmationModalProps) => {
    const ref = useRef(null);
    useOnClickOutside(ref, onClose);
    return (
        <>
            {
                <Popover
                    classNames={
                        conditions(ConditionName.isTouchScreenLandscape) ? "pl-w-[360px] pl-max-h-[90vh] pl-relative" : "pl-w-[360px] pl-relative"
                    }
                    type={"modal"}
                    onClose={() => {}}
                    ref={ref}
                    status={status}
                    isBlurBackground={true}
                >
                    {modalType === "DELETE" ? (
                        <div className="pl-flex pl-justify-between pl-flex-col pl-p-4 pl-w-full pl-h-full pl-rounded-[8px] pl-border-t-[8px] pl-border-t-red-200 pl-border-r-none pl-border-l-none">
                            <div
                                className={`pl-absolute pl-left-0 pl-w-[40px] pl-h-[40px] pl-rounded-full pl-bg-red-200 pl-top-[-20px] ${
                                    isTouchScreen() && !conditions(ConditionName.isTouchScreenLandscape)
                                        ? "pl-right-[calc(50vw-20px)]"
                                        : "pl-left-[160px]"
                                } pl-flex pl-items-center pl-justify-center`}
                            >
                                <Image className="pl-w-full pl-h-full" src={IMAGES.trashDeleteModal} width={25} height={25} alt={"trash"} />
                            </div>
                            <div className="pl-pt-4 pl-w-full">{text}</div>
                            {children}
                            <div className="pl-flex pl-items-end pl-justify-between pl-w-full pl-pt-6">
                                <button className="pl-w-1/2 pl-h-[40px] pl-bg-red-600 pl-rounded-[8px] pl-text-white" onClick={onSubmit}>
                                    {submitButtonText}
                                </button>
                                <button
                                    className="pl-w-1/2 pl-h-[40px] pl-rounded-[8px] dark:pl-text-z-secondary-50 pl-text-gray-500"
                                    onClick={onClose}
                                >
                                    {cancelButtonText}
                                </button>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}
                </Popover>
            }
        </>
    );
};

export default ConfirmationModal;
